export default "__VITE_ASSET__D8wtBi6X__"